const getConfigAxios = (token = null, contentType = 'application/json') => {
  if (token) {
    return {
      headers: {
        Authorization: 'Bearer ' + token,
        Accept: 'application/json',
        'Content-Type': contentType
      }
    }
  } else {
    return {
      withCredentials: true,
      headers: { Accept: 'application/json' }
    }
  }
}

export { getConfigAxios }
